import React from 'react';
import { ShieldCheck, Lock, ChevronRight } from 'lucide-react';

const VerificationBadge = ({ onVerify, collegeName }) => {
  return (
    <div className="flex flex-col items-center w-full mt-6 animate-in fade-in slide-in-from-bottom-2 duration-1000">
      
      {/* The Interactive Badge */}
      <button 
        onClick={onVerify}
        className="group relative flex items-center space-x-3 bg-white hover:bg-blue-50 border border-slate-200 hover:border-blue-200 p-1.5 pr-5 rounded-full shadow-sm hover:shadow-md transition-all active:scale-95"
      >
        {/* Icon Cluster */}
        <div className="relative">
          <div className="bg-blue-600 text-white p-2 rounded-full shadow-lg shadow-blue-200">
            <ShieldCheck size={16} strokeWidth={2.5} />
          </div>
          <div className="absolute -top-1 -right-1 bg-slate-900 text-[8px] text-white p-0.5 rounded-full border border-white">
            <Lock size={8} />
          </div>
        </div>

        {/* Text Content */}
        <div className="flex flex-col items-start text-left">
          <p className="text-[10px] font-black text-slate-900 uppercase tracking-tight leading-none mb-0.5">
            Unlock {collegeName || 'Campus'} Vault
          </p>
          <div className="flex items-center space-x-2 text-[9px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap">
            <span>Seniors</span>
            <span className="w-1 h-1 bg-slate-300 rounded-full"></span>
            <span>Interviews</span>
            <span className="w-1 h-1 bg-slate-300 rounded-full"></span>
            <span>Material</span>
          </div>
        </div>

        {/* Action Arrow */}
        <ChevronRight size={14} className="text-slate-300 group-hover:text-blue-600 group-hover:translate-x-1 transition-all" />
      </button>

      {/* Subtle Hint (Optional) */}
      <p className="mt-3 text-[9px] font-bold text-slate-400 uppercase tracking-[0.2em] opacity-60">
        Verify to claim your badge
      </p>
    </div>
  );
};

export default VerificationBadge;